export default "__VITE_ASSET__CrVa0TgR__"